/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./collect-sms.vue.js?vue&type=template&id=468bfaf7!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./collect-sms.vue?vue&type=template&id=468bfaf7"
import script from "./collect-sms.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./collect-sms.vue?vue&type=script&setup=true&lang=js"
export * from "./collect-sms.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./collect-sms.vue?vue&type=script&setup=true&lang=js"
import style0 from "./collect-sms.vue.postcss?vue&type=style&index=0&id=468bfaf7&prod&lang=postcss&module=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./collect-sms.vue?vue&type=style&index=0&id=468bfaf7&prod&lang=postcss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports